export default __webpack_public_path__ + "static/media/032-hook.66868ce6.png";